<template>
  <div class="cart-container">
    <v-row
      v-for="(item, index) in $store.state.cartContent"
      :key="item"
      class="cart-item-row"
    >
      <v-card
        class="product-card"
        :class="{'grayscale': item.product.availableQuantityForPeriod === 0}"
        style="width: 100%; display: flex; flex-direction: column; overflow: hidden;"
      >
        <v-row style="width: 100%;">
          <!-- Left column for image -->
          <v-col
            cols="4"
            style="overflow: hidden;"
          >
            <v-img
              class="flexImageCard"
              :src="getimgUrl(item,index)"
              contain
              @error="handleImageError(index)"
            />
          </v-col>

          <!-- Right column for details and controls -->
          <v-col
            cols="8"
            style="display: flex; flex-direction: column; justify-content: space-between;"
          >
            <v-card-text>
              <div class="title">
                {{ item.product.name }}
              </div>
              <div class="subtitle">
                {{ item.product.type }}
              </div>
            </v-card-text>
            
            <!-- Amount selector -->
            <div class="amount-selector">
              <v-btn
                size="x-small"
                icon
                :disabled="item.amount <= 0"
                @click.stop.prevent="decrement(index)"
              >
                <v-icon size="small">
                  mdi-minus
                </v-icon>
              </v-btn>
              <span>{{ item.amount <= 0 ? 0 : item.amount }}</span>
              <v-btn
                size="x-small"
                icon
                :disabled="getIncrementButtonDisabledState(item) || item.amount <= 0"
                @click.stop.prevent="increment(index)"
              >
                <v-icon size="small">
                  mdi-plus
                </v-icon>
              </v-btn>
              <v-btn
                size="x-small"
                icon
                @click.stop.prevent="deleteProductFromCart(index)"
              >
                <v-icon size="small">
                  mdi-trash-can
                </v-icon>
              </v-btn>
            </div>
          </v-col>
        </v-row>
        <v-list-item-title>{{ item.product.text }}</v-list-item-title>
      </v-card>
    </v-row>
  </div>
</template>

<script>
import productService from '@/services/productService';
import config from '@/config/config';

export default {
  data() {
    return {
      loading: false,
      imageLoadError: new Array(this.$store.state.cartContent.length).fill(false)
    };
  },
  async mounted() {
    await this.setProductAvailabilityForPeriod();
  },
  methods: {
    increment(productIndex) {
      this.$store.commit('INCREMENT_PRODUCT_AMOUNT', productIndex);
    },
    decrement(productIndex) {
      if (this.$store.state.cartContent[productIndex].amount > 1) {
        this.$store.commit('DECREMENT_PRODUCT_AMOUNT', productIndex);
      } else {
        this.deleteProductFromCart(productIndex);
      }
    },
    getimgUrl(item,index) {
      if (this.imageLoadError[index] || !item.product.inventoryNumber) {
        return require('@/assets/no_image.jpg');
      }
      return `${config.backendUrl}/uploads/${item.product.inventoryNumber}.jpg`;
    },
    async setProductAvailabilityForPeriod() {
      this.loading = true;
      try {
        const response = await productService.getAvailableProducts({
          rentalStartDate: this.$store.getters.getStartDate,
          rentalEndDate: this.$store.getters.getEndDate
        });

        const cartContent = this.$store.state.cartContent;
        if (response.data) {
          cartContent.forEach(product => {
            const rentedProduct = response.data.find(rp => rp.serialNumber === product.product.serialNumber);
            product.product.availableQuantityForPeriod = rentedProduct 
              ? product.product.quantity - rentedProduct.rentedQuantity 
              : product.product.quantity;
            
            if (product.amount > product.product.availableQuantityForPeriod) {
              product.amount = product.product.availableQuantityForPeriod;
            }
          });
        } else {
          cartContent.forEach(product => {
            product.product.availableQuantityForPeriod = product.product.quantity;
          });
        }

        if (cartContent.some(product => product.product.availableQuantityForPeriod === 0)) {
          this.$snackbar.add({
            type: 'info',
            text: this.$t('itemsInCartNotAvailableForPeriod'),
            duration: 10000
          });
        }
      } catch (error) {
        console.error('Error fetching available products:', error);
      } finally {
        this.loading = false;
      }
    },
    getIncrementButtonDisabledState(item) {
      return item.product.availableQuantityForPeriod <= item.amount;
    },
    deleteProductFromCart(productIndex) {
      this.$store.commit('REMOVE_PRODUCT_FROM_CART', {
        productIndex,
        snackBarText: this.$t('itemRemovedFromCart')
      });
    },
    handleImageError(index) {
      this.imageLoadError[index] = true; // Prevent infinite loop in case the fallback image also fails
    }
  }
};
</script>

<style scoped>
.cart-container {
  width: 100%;
  padding: 0 16px;
}

@media (max-width: 600px) {
  .cart-container {
    padding: 0 8px;
  }
}

.cart-item-row {
  width: 100%;
}

.product-card {
  margin-bottom: 10px;
  padding: 10px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}

.flexImageCard {
  width: 100px;
  height: 100px;
  object-fit: contain;
  border-radius: 5px;
  pointer-events: none;
  background-color: transparent;
}

.title {
  font-size: 16px;
  font-weight: bold;
}

.subtitle {
  font-size: 14px;
  color: grey;
}

.amount-selector {
  margin-top: 10px;
  display: flex;
  align-items: center;
  gap: 5px;
}

.grayscale {
  filter: grayscale(100%);
}

@media (max-width: 600px) {
  .flexImageCard {
    width: 80px;
    height: 80px;
  }

  .title {
    font-size: 14px;
  }

  .subtitle {
    font-size: 12px;
  }
}
</style>
